<ng-template #customLoadingTemplate>
  <div style="z-index: 1998;position: absolute;right: 0;bottom: 0;width: calc(100% - 150px);height: 100%;  background-color: #fff;"></div>
</ng-template>
<ngx-loading [template]="customLoadingTemplate" [show]="loading()"></ngx-loading>
<div class="container-fluid">
  <div class="row" >
    <div class="col-md-2 p-0">
      <app-treeview class="treeview-container" [selectionActivee]="false" [listeTirs]="listeTirs()" [noeudSelectionne]="noeudSelectionne()"
        [tirSelectionne]="tirId()" [siteId]="siteId()" [projetId]="projetId()" (tirCree)="onTirCree($event)">
      </app-treeview>
    </div>
    <!-- <div class="menu-projet">
    <ng-container *ngIf="!utilService.currentProjet?.dateFinEffective || dateProjet > currentDate">
      <a *showIfHasRole="'create_blast'" (click)="openModalcreateTir()" class="nav-link" style="cursor:pointer;"><i class="fas fa-plus" style="padding-right: 5px;"></i>{{'TIR.CREER_UN_TIR' | translate}}</a>
    </ng-container>
    <div id="navigation-etapes">
      <ul id="liste-etapes" class="flex-column">
        <ng-container *ngIf="!etapeId">
          <li class="nav-item item-etape align-items-center d-flex" *ngFor="let etape of utilService.currentTir?.workflowInstance?.workflowEtapeInstances; let i = index;" [ngClass]="{'item-selected':utilService.currentEtape?.workflowEtapeInstanceId == etape.workflowEtapeInstanceId}">
            <a class="nav-link  w-100" [routerLink]="['/mysite', utilService.currentSite()?.siteId, 'myprojects', projetId]" [queryParams]="{ blastId: utilService.currentTir?.tirId, stepId: etape.workflowEtapeInstanceId}" [title]="etape.nom">{{etape.nom}}</a>
            <i class="fas fa-file" style="margin-right: 5px;" *ngIf="etape.estRenseignee"></i>
            <i class="fas fa-eye"  [ngClass]="{'fa-eye': etape.accessPermission === 1, 'fa-eye-slash': etape.accessPermission === 0}" ></i>
            <i *ngIf="etape.accessPermission === 2" class="fas fa-user-edit"></i>
            <div class="pointe-fleche" *ngIf="showPointe && i == utilService.currentTir?.workflowInstance?.workflowEtapeInstances.length - 1"></div>
          </li>
        </ng-container>
        <ng-container *ngIf="etapeId">
          <li class="nav-item item-etape-bis align-items-center d-flex" *ngFor="let etape of utilService.currentTir?.workflowInstance?.workflowEtapeInstances; let i = index;" [ngClass]="{'item-selected':utilService.currentEtape?.workflowEtapeInstanceId == etape.workflowEtapeInstanceId}">
            <a class="nav-link  w-100" [routerLink]="['/mysite', utilService.currentSite()?.siteId, 'myprojects', projetId]" [queryParams]="{ blastId: utilService.currentTir?.tirId, stepId: etape.workflowEtapeInstanceId}" [title]="etape.nom">{{etape.nom}}</a>
            <i class="fas fa-file" style="margin-right: 5px;" *ngIf="etape.estRenseignee"></i>
            <i class="fas fa-eye" [ngClass]="{'fa-eye': etape.accessPermission === 1, 'fa-eye-slash': etape.accessPermission === 0}" ></i>
            <i *ngIf="etape.accessPermission === 2" class="fas fa-user-edit"></i>
            <div class="pointe-fleche" *ngIf="i == utilService.currentTir?.workflowInstance?.workflowEtapeInstances.length - 1"></div>
          </li>
        </ng-container>
      </ul>
    </div>
  </div> -->
  @if (utilService.currentTir != null) {
    <div class="col-md-2 p-0">
      @if (ecranAffiche() === EcranAffiche.EcranTir) {
        <app-tir-info [tir]="utilService.currentTir" (suppTir)="recupProjet(true)" (modifTir)="tirModifie($event)"></app-tir-info>
      }
    </div>
  }

  <div class="col-md-8 p-0">
    @if (ecranAffiche() === EcranAffiche.EcranProjet && utilService.currentTir == null) {
      <div id="partie-detail" class="col">
        <app-projet-detail [projet]="utilService.currentProjet" [siteId]="siteId()" ></app-projet-detail>
      </div>
    }
    @if (ecranAffiche() === EcranAffiche.EcranTir && utilService.currentTir != null) {
      <div id="partie-detail" class="col">
        <app-tir-detail [projet]="utilService.currentProjet" [usePostgresDatabaseForVibrations]="utilService.currentProjet?.usePostgresDatabaseForVibrations" [tir]="utilService.currentTir" [siteId]="siteId()" [etape]="utilService.currentEtape"
        (isSecurityChange)="isSecurityChange($event)" [regionId]="this.utilService.currentSite().regionId"></app-tir-detail>
      </div>
    }
    @if (ecranAffiche() === EcranAffiche.EcranNoeud) {
      <div id="partie-detail" class="col">
        <app-noeud-detail [projet]="utilService.currentProjet" [siteId]="siteId()"></app-noeud-detail>
      </div>
    }
  </div>
</div>
</div>

